// Copyright (c) 2015, Daffy Technologies Pvt. Ltd. and Contributors
// MIT License. See license.txt

// for translation
daffy._messages = {};
daffy._ = function(txt, replace) {
	if(!txt)
		return txt;
	if(typeof(txt) != "string")
		return txt;
	var ret = daffy._messages[txt.replace(/\n/g, "")] || txt;
	if(replace && typeof(replace) === "object") {
		ret = $.format(ret, replace);
	}
	return ret;
};
window.__ = daffy._

daffy.get_languages = function() {
	if(!daffy.languages) {
		daffy.languages = []
		$.each(daffy.boot.lang_dict, function(lang, value){
			daffy.languages.push({'label': lang, 'value': value})
		});
		daffy.languages = daffy.languages.sort(function(a, b) { return (a.value < b.value) ? -1 : 1 });
	}
	return daffy.languages;
};
